import React, {useState} from 'react';
import {
  Card,
  CardBoldText,
  ThumbCardContainer,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable, Image } from 'react-native';
import Modal from './Modal';
import { useMutation } from '@apollo/client';
import { REMOVE_ATTACHMENT } from '../components/Attachments/queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { elRed } from 'app/src/styles/colors';

const thumbnail = {
  width: '100px'
}

const full = {
  width: '100%'
}

const PhotoCard = props => {
  const { attachment, updateAttachments } = props;
  const [showPhotoModal, setShowPhotoModal] = useState(false);

  const [removeAttachment] = useMutation(REMOVE_ATTACHMENT, {
    onCompleted: (response) => {
      updateAttachments(
        'Photo',
        'remove',
        response.removeAttachment.attachment
      )
    }
  });

  const onRemove = () => {
    removeAttachment({ variables: {id: attachment.id} });
  }

  return (
    <ThumbCardContainer>
      <Pressable
        style={{
          marginBottom: '-25px',
          marginRight: '2px',
          zIndex: 9999999,
          alignSelf: 'flex-end'
        }}
        onPress={() => {
          if(window.confirm('Remove Photo?')) {
            onRemove();
          }
        }}
      >
        <FontAwesomeIcon
          icon={faSquareXmark}
          size='xl'
          style={{color: elRed}}
          // onClick={() => setShowModal(false)}
        />
      </Pressable>
      <Card>
        <Pressable
          onPress={() => setShowPhotoModal(true)}
          style={{alignSelf: 'flex-end'}}
        >
          {/* <Image
            style={thumbnail}
            source={require(attachment.url)}
          /> */}
          <img src={attachment.url} style={thumbnail} />
        </Pressable>
      </Card>
      {showPhotoModal &&
        <Modal
          showModal={showPhotoModal}
          setShowModal={setShowPhotoModal}
          modalType={attachment.filename}
        >
          <img src={attachment.url} style={full} />
          <br />
        </Modal>
      }
    </ThumbCardContainer>
  )
}

export default PhotoCard;